import Services from '../../api/service'
import { Link } from "react-router-dom";
import { Fade } from "react-awesome-reveal";
import sIcon from '../../images/icon/arrow-black.svg'
import hIcon from '../../images/icon/ser-01.svg'

const ServiceSection = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section id="agentes" className="service pt-140 pb-140">
            <div className="container">
                <div className="row mt-none-30">
                    <div className="col-lg-4 mt-30">
                        <div className="service-info">
                            <div className="sec-title--two">
                                <Fade direction='down' triggerOnce={'false'} duration={1000} delay={9}>
                                    <div>
                                        <span className='sub-title'><img src={hIcon} alt="" />Soluções Inteligentes</span>
                                    </div>
                                </Fade>
                                <Fade direction='up' triggerOnce={'false'} duration={1200} delay={9}>
                                    <div>
                                        <h2 className="title"> Cresça com <br /> Agentes de IA</h2>
                                    </div>
                                </Fade>
                                <Fade direction='up' triggerOnce={'false'} duration={1400} delay={9}>
                                    <div>
                                        <p className="content">Transforme sua empresa com agentes inteligentes para vendas, atendimento e criação de conteúdo.</p>
                                    </div>
                                </Fade>
                            </div>
                            <div className="xb-btn mt-50">
                                <Fade direction='up' triggerOnce={'false'} duration={1600} delay={9}>
                                    <div>
                                        <a 
                                            href="https://wa.me/5519981572542?text=Olá!%20Gostaria%20de%20saber%20mais%20sobre%20os%20Agentes%20de%20Inteligência%20Artificial.%20Podem%20me%20ajudar?" 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                            className="thm-btn thm-btn--aso thm-btn--aso_yellow"
                                        >
                                            Explorar todos
                                        </a>
                                    </div>
                                </Fade>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mt-30">
                        <div className="service-all_item">
                            {Services.slice(0, 3).map((service, srv) => (
                                <div className="service-box" key={srv}>
                                    {service.title ?
                                        <div className="service-item">
                                            <div className="xb-item--holder mb-85">
                                                <h3 className="xb-item--title">{service.title}</h3>
                                                <span className="xb-item--contact">{service.description}</span>
                                            </div>
                                            <div className="xb-item--icon ul_li_between">
                                                <div className="xb-item--img"><img src={service.sImg} alt="" />
                                                </div>
                                                <a 
                                                    href={`https://wa.me/5519981572542?text=Olá!%20Gostaria%20de%20saber%20mais%20sobre%20${encodeURIComponent(service.title)}.%20Podem%20me%20ajudar?`}
                                                    target="_blank" 
                                                    rel="noopener noreferrer"
                                                    className="xb-item--arrow"
                                                >
                                                    <img src={sIcon} alt="" />
                                                </a>
                                            </div>
                                            <a 
                                                href={`https://wa.me/5519981572542?text=Olá!%20Gostaria%20de%20saber%20mais%20sobre%20${encodeURIComponent(service.title)}.%20Podem%20me%20ajudar?`}
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                                className="xb-overlay"
                                            ></a>
                                        </div>
                                        : ''}
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mt-30">
                        <div className="service-all_item">
                            {Services.slice(3, 6).map((service, srv) => (
                                <div className="service-box" key={srv}>
                                    {service.title ?
                                        <div className="service-item">
                                            <div className="xb-item--holder mb-85">
                                                <h3 className="xb-item--title">{service.title}</h3>
                                                <span className="xb-item--contact">{service.description}</span>
                                            </div>
                                            <div className="xb-item--icon ul_li_between">
                                                <div className="xb-item--img"><img src={service.sImg} alt="" />
                                                </div>
                                                <a 
                                                    href={`https://wa.me/5519981572542?text=Olá!%20Gostaria%20de%20saber%20mais%20sobre%20${encodeURIComponent(service.title)}.%20Podem%20me%20ajudar?`}
                                                    target="_blank" 
                                                    rel="noopener noreferrer"
                                                    className="xb-item--arrow"
                                                >
                                                    <img src={sIcon} alt="" />
                                                </a>
                                            </div>
                                            <a 
                                                href={`https://wa.me/5519981572542?text=Olá!%20Gostaria%20de%20saber%20mais%20sobre%20${encodeURIComponent(service.title)}.%20Podem%20me%20ajudar?`}
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                                className="xb-overlay"
                                            ></a>
                                        </div>
                                        : ''}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ServiceSection;